<template>
  <div id="jcom-business-category-list">
    <v-overlay :value="ProgessStart">
      <div class="d-flex justify-content-center align-items-center">
        <b-spinner variant="primary" type="grow" label="Loading..."></b-spinner>
      </div>
    </v-overlay>

    <!-- Premium Page Header -->
    <v-card elevation="20" class="header-card mb-6 overflow-hidden">
      <div class="header-backdrop-effect"></div>
      <v-container class="header-container py-0">
        <v-row align="center" class="py-6">
          <v-col cols="auto" class="flex-shrink-1">
            <div class="header-icon-box">
              <v-icon size="48" color="white">mdi-folder-multiple</v-icon>
            </div>
          </v-col>
          <v-col cols="auto" class="flex-grow-0">
            <h1 class="header-title">{{ PageTitle }}</h1>
            <p class="header-subtitle">{{ PageDescription }}</p>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="auto" class="flex-shrink-1">
            <div class="action-btn-group">
              <v-btn
                icon
                color="white"
                @click="refreshPageData"
                class="action-icon-btn"
                elevation="0"
              >
                <v-icon size="28">mdi-refresh</v-icon>
              </v-btn>
              <v-btn
                icon
                color="white"
                @click.prevent="addRecord"
                class="action-icon-btn"
                elevation="0"
              >
                <v-icon size="28">mdi-plus-circle</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-card-text class="page-content">
      <v-container>

        <v-row justify="center" v-if="ErrorMessageTxtFlag == 1">
          <v-col cols="12">
            <v-alert type="error" prominent border="left" class="premium-alert premium-alert--error">
              <div class="premium-alert-content">
                <div class="alert-icon-wrapper">
                  <v-icon class="alert-icon">mdi-alert-circle</v-icon>
                </div>
                <div class="alert-body">
                  <h4 class="premium-alert-title">Error</h4>
                  <p class="premium-alert-message">{{ ErrorMessageTxt }}</p>
                </div>
              </div>
            </v-alert>
          </v-col>
        </v-row>

        <v-row justify="center" v-if="tableData1.length > 0">
          <v-col cols="12">
            <div class="stats-card">
              <v-icon size="32" color="#1db954">mdi-checkbox-marked-circle</v-icon>
              <h3 class="stats-number">{{ tableData1.length }}</h3>
              <p class="stats-label">Total Categories</p>
            </div>
          </v-col>

          <v-col cols="12" class="d-flex justify-space-between align-center">
            <v-text-field
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              label="Search Categories"
              outlined
              dense
              class="search-field flex-grow-1"
              hide-details
            ></v-text-field>
            <json-excel
              v-if="ExcelDownloadFlag"
              :data="tableData1"
              :fields="ExcelFields"
              worksheet="Business Categories"
              :name="ExcelFileName"
              class="ml-3"
            >
              <v-btn
                color="#1db954"
                class="white--text"
                elevation="0"
                rounded
              >
                <v-icon left small>mdi-download</v-icon>
                Download Excel
              </v-btn>
            </json-excel>
          </v-col>
          
          <v-col cols="12">
            <v-data-table
              class="elevation-0 professional-table"
              v-model="selected1"
              :search="search"
              :item-key="tableOptions1.ItemKey"
              :single-select="tableOptions1.SingleSelectFlag"
              :headers="tableColumns1"
              :items="tableData1"
              :items-per-page="tableOptions1.ItemsPerPage"
              :footer-props="tableOptions1.FooterProps"
              :no-data-text="'No categories found'"
            >
              <template v-slot:[`item.BusinessCategoryStatusTxt`]="{ item }">
                <v-chip
                  small
                  :text-color="item.BusinessCategoryStatusColor"
                  :color="getChipBackgroundColor(item.BusinessCategoryStatusColor)"
                  class="status-chip"
                >
                  <v-icon small left>{{ item.BusinessCategoryStatusTxt === 'Active' ? 'mdi-check-circle' : 'mdi-close-circle' }}</v-icon>
                  {{ item.BusinessCategoryStatusTxt }}
                </v-chip>
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      x-small
                      color="primary"
                      @click="editData(item)"
                      v-bind="attrs"
                      v-on="on"
                      v-if="item.EditFlag"
                      class="action-icon-table"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit Category</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        <v-row justify="center" v-else>
          <v-col cols="12">
            <div class="empty-state">
              <v-icon size="64" color="#ccc">mdi-folder-open-outline</v-icon>
              <h3>No Categories Found</h3>
              <p>Create a new business category to get started</p>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <!-- Add Dialog -->
    <v-dialog
      v-model="AddRecordPrompt"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <jcom-business-category-create
        :showDialog="AddRecordPrompt"
        @hideDialog="hideAddRecordPrompt"
        v-if="AddRecordPrompt"
      />
    </v-dialog>

    <v-dialog
      v-model="editRecordPrompt"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <JcomBusinessCategoryEdit
        pageDescription="Edit Business Category"
        :editRecordPrompt="editRecordPrompt"
        :recordData="selectedData"
        @hideDialog="hideEditRecordPrompt"
        v-if="editRecordPrompt"
      ></JcomBusinessCategoryEdit>
    </v-dialog>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";
import JcomBusinessCategoryCreate from "./JcomBusinessCategoryCreate.vue";
import JcomBusinessCategoryEdit from "./JcomBusinessCategoryEdit.vue";

export default {
  mixins: [common],
  components: {
    JcomBusinessCategoryEdit,
    JcomBusinessCategoryCreate,
  },
  data() {
    return {
      search: "",
      ProgessStart: 0,
      uploadPercentage: 0,
      selectedData: {},

      SuccessMessageTxtFlag: 0,
      SuccessMessageTxt: "",

      ErrorMessageTxtFlag: 0,
      ErrorMessageTxt: "",

      alert: {},

      valid: true,

      RoleId: "",

      ResultFlag: 0,
      BtnShowFlag: 0,

      singleSelect: true,
      selected1: [],
      selected2: [],
      loading: true,

      AddRecordPrompt: false,
      editRecordPrompt: false,

      recordToEdit: "",
      recordData: {},

      dialog: false,
      dialogDelete: false,
      rows: [],
      tableData1: [],
      tableOptions1: [],
      tableColumns1: [],

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
      FloatingButtonOptions: {},
      ExcelFileName: "",
      ExcelFields: [],
      ExcelDownloadFlag: false,
    };
  },
  computed: {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        var flag = tr.PagePermissionFlag;
        console.log("PagePermissionFlag=" + flag);

        if (!flag) {
          this.$router.push("/access-denied");
        }

        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;
        this.FloatingButtonOptions = tr.FloatingButtonOptions;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        this.CurrentYearId = CurrentJciYearId;
        this.JciYearCode = CurrentJciYearId;

        this.searchForm();
      }
    },
    rows: function () {
      console.log("watch rows");
      var rows = this.rows;
      var n1 = rows.length;
      var flag = n1 == 0 ? 0 : 1;
      console.log("n1=" + n1 + ", flag=" + flag);
      this.ResultFlag = flag;
    },
  },
  created() {
    // this.initialize()
  },
  methods: {
    rowSelected(tr) {
      console.log("rowSelected called");
      console.log("tr=" + JSON.stringify(tr));
    },
    addRecord() {
      console.log("addRecord called");
      this.AddRecordPrompt = true;
    },
    hideAddRecordPrompt() {
      console.log("hideAddRecordPrompt called");
      this.AddRecordPrompt = false;
      this.searchForm();
    },
    resetFrom() {
      console.log("resetFrom called");
      this.tableColumns1 = {};
      this.tableOptions1 = {};
      this.tableData1 = {};

      this.DownloadFlag = false;
      this.ExcelFileName = "";
      this.ZipDownloadFlag = false;
      this.ZipFileName = "";
      this.tableData1 = [];
      this.selected1 = [];
    },
    resetMessageTxt() {
      console.log("resetMessageTxt called");
      this.ErrorMessageTxt = 0;
      this.ErrorMessageTxtFlag = "";
      this.SuccessMessageTxtFlag = 0;
      this.SuccessMessageTxt = "";
      this.totalActiveAwards = 0;
      this.totalPendingAwards = 0;
    },
    hideEditRecordPrompt(flag) {
      console.log("hideEditRecordPrompt called");
      this.editRecordPrompt = false;
      console.log("flag = " + flag);
      if (flag) {
        this.searchForm();
      }
    },
    editData(tr) {
      console.log("editData called");
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.selectedData = tr;
        this.editRecordPrompt = true;
        console.log("this.selectedData=" + JSON.stringify(this.selectedData));
      } else {
        var message = "Kindly select one category to edit";
        this.toast("error", message);
      }
    },
    getChipBackgroundColor(textColor) {
      if (textColor === '#1db954' || textColor === 'green' || textColor === '#2e7d32') {
        return '#f1f5fe';
      } else if (textColor === '#ff6b6b' || textColor === 'red' || textColor === '#c62828') {
        return '#ffebee';
      } else {
        return '#f5f5f5';
      }
    },
   
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "jcom_business_category",
        Action: "list",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    searchForm() {
      console.log("searchForm called");

      this.resetMessageTxt();

      var ZoneCode = this.ZoneCode;
      var JcomTable = this.JcomTable;
      console.log("ZoneCode=" + ZoneCode + ", JcomTable=" + JcomTable);

      this.DownloadFlag = false;
      this.ExcelFileName = "";
      this.ZipDownloadFlag = false;
      this.ZipFileName = "";
      this.tableData1 = [];
      this.selected1 = [];

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/jcom/business-category/lists-v2";
      var upload = {
        UserInterface: 1,
      };
      console.log("upload=" + JSON.stringify(upload));
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      const thisIns = this;
      var output = "";
      var records = [];
      var table_content = [];
      var successTxt = "";
      var errorTxt = "";
      var flag = 0;

      // thisIns.pageLoadingOn()
      thisIns.ProgessStart = 1;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          // thisIns.pageLoadingOff()
          thisIns.ProgessStart = 0;

          output = response.data.output;
          flag = response.data.flag;
          table_content = response.data.records;
          console.log("output=" + output + ", flag=" + flag);

          var options = table_content.TableOptions;
          records = table_content.TableData;

          if (flag == 1) {
            thisIns.tableColumns1 = table_content.TableHeader;
            thisIns.tableOptions1 = options;
            thisIns.tableData1 = records;
            thisIns.ExcelFields = options.ExcelFields || [];
            thisIns.ExcelFileName = options.ExcelFileName || "BusinessCategories.xlsx";
            thisIns.ExcelDownloadFlag = options.ExcelDownloadButtonFlag || false;
            thisIns.toast("success", output);
          } else {
            console.log("error=" + output);
            thisIns.toast("error", output);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
        });
    },
  },
  beforeMount() {
    var RoleId = this.$session.get("RoleId");
    RoleId = RoleId == (null || undefined) ? "" : RoleId;
    console.log({ RoleId });
    this.RoleId = RoleId;
    // this.RoleId = 1;

    this.refreshPageData();
  },
};
</script>

<style lang="scss">
// Color Palette
$navy: #3a67b1;
$aqua: #0097d7;
$gold: #edbe38;
$seaform: #56bda3;
$text-90-black: #414042;
$text-off-black: #0a0f29;
$text-white: #ffffff;
$success-color: #1db954;
$danger-color: #e74c3c;
$info-color: $aqua;
$bg-light: #f8fafc;
$border-color: #e2e8f0;

// Animations
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-12px);
  }
}

@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

#jcom-business-category-list {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
  padding: 30px 15px;

  // ============================================
  // HEADER CARD
  // ============================================
  .header-card {
    background: linear-gradient(135deg, $navy 0%, $aqua 100%) !important;
    border-radius: 20px;
    overflow: hidden;
    animation: slideDown 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
    position: relative;
    border: none;
    box-shadow: 0 20px 60px rgba(58, 103, 177, 0.5), 0 0 20px rgba(0, 151, 215, 0.3);

    &::before {
      content: '';
      position: absolute;
      top: -50%;
      right: -20%;
      width: 400px;
      height: 400px;
      background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
      border-radius: 50%;
      animation: float 8s ease-in-out infinite;
    }

    .header-backdrop-effect {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120"><path d="M0,50 Q300,10 600,50 T1200,50 L1200,120 L0,120 Z" fill="rgba(255,255,255,0.05)"/></svg>') no-repeat bottom;
      background-size: cover;
      pointer-events: none;
    }
  }

  .header-container {
    padding: 20px 30px !important;
    position: relative;
    z-index: 1;
  }

  .header-icon-box {
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0.1) 100%);
    backdrop-filter: blur(15px);
    border-radius: 18px;
    padding: 14px;
    margin-right: 24px;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.4);
    animation: float 4s ease-in-out infinite;
    border: 2px solid rgba(255, 255, 255, 0.3);
  }

  .header-title {
    font-size: 36px;
    font-weight: 900;
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3), 0 0 20px rgba(0, 151, 215, 0.3);
    animation: slideDown 0.8s ease-out;
    letter-spacing: 0.8px;
    color: $text-white;
    margin: 0;
  }

  .header-subtitle {
    font-size: 16px;
    opacity: 0.98;
    animation: slideDown 1s ease-out 0.1s backwards;
    letter-spacing: 0.4px;
    color: rgba($text-white, 0.95);
    font-weight: 500;
    margin: 6px 0 0 0;
  }

  .action-btn-group {
    display: flex;
    gap: 12px;
    align-items: center;
    margin-left: 24px;
  }

  .action-icon-btn {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    background: rgba(255, 255, 255, 0.15) !important;
    border: 2px solid rgba(255, 255, 255, 0.3) !important;
    backdrop-filter: blur(10px);
    border-radius: 12px !important;

    &:hover {
      background: rgba(255, 255, 255, 0.25) !important;
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
      transform: translateY(-2px);
    }

    &:active {
      transform: translateY(0);
    }
  }

  // ============================================
  // PAGE CONTENT
  // ============================================
  .page-content {
    background: transparent !important;
    padding: 20px 0 !important;
  }

  // ============================================
  // STATS CARD
  // ============================================
  .stats-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background: linear-gradient(135deg, $bg-light 0%, white 100%);
    border-radius: 16px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
    border: 1px solid $border-color;
    animation: fadeInScale 0.6s ease-out;

    .stats-number {
      font-size: 42px;
      font-weight: 900;
      color: $navy;
      margin: 12px 0 8px 0;
    }

    .stats-label {
      font-size: 14px;
      color: $text-90-black;
      font-weight: 600;
      margin: 0;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }
  }

  // ============================================
  // SEARCH FIELD
  // ============================================
  .search-field {
    margin-bottom: 24px !important;

    .v-input__control {
      .v-input__slot {
        background: white !important;
        border-radius: 12px !important;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important;
        border: 1px solid $border-color !important;
      }
    }

    input {
      font-size: 15px !important;
      color: $text-off-black;

      &::placeholder {
        color: #999;
      }
    }

    .v-input__prepend-inner {
      color: $info-color !important;
      font-size: 20px;
    }

    &:hover .v-input__slot {
      border-color: $info-color !important;
    }

    &.v-input--is-focused .v-input__slot {
      box-shadow: 0 4px 16px rgba(0, 151, 215, 0.2) !important;
      border-color: $info-color !important;
    }
  }

  // ============================================
  // DATA TABLE
  // ============================================
  .professional-table {
    background: white !important;
    border-radius: 16px !important;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08) !important;
    overflow: hidden !important;

    .v-data-table__wrapper {
      border-radius: 16px !important;

      table {
        border-collapse: collapse !important;
      }
    }

    thead {
      background: linear-gradient(135deg, #f0f4f8 0%, #e8f1f6 100%);
      border-bottom: 2px solid $border-color;

      th {
        font-size: 13px !important;
        font-weight: 700 !important;
        color: $text-off-black !important;
        text-transform: uppercase !important;
        letter-spacing: 0.5px !important;
        padding: 18px 16px !important;
        background: transparent !important;

        &:first-child {
          border-radius: 16px 0 0 0 !important;
        }

        &:last-child {
          border-radius: 0 16px 0 0 !important;
        }
      }
    }

    tbody {
      tr {
        border-bottom: 1px solid $border-color !important;
        transition: all 0.3s ease;

        &:hover {
          background: linear-gradient(90deg, rgba(0, 151, 215, 0.04) 0%, rgba(58, 103, 177, 0.04) 100%) !important;
          box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.02);
        }

        &:last-child {
          border-bottom: none !important;
        }

        td {
          font-size: 14px !important;
          color: $text-90-black !important;
          padding: 16px !important;
          vertical-align: middle !important;
          font-weight: 500;

          .v-chip {
            font-weight: 600 !important;
            height: 32px !important;
            font-size: 12px !important;
          }
        }
      }
    }

    .v-data-table-footer {
      border-top: 2px solid $border-color !important;
      background: linear-gradient(135deg, #f0f4f8 0%, #e8f1f6 100%) !important;
      padding: 16px !important;
      font-size: 13px !important;

      .v-pagination {
        .v-pagination__navigation button,
        .v-pagination__item {
          color: $navy !important;
          min-width: 40px !important;
          height: 40px !important;
          border-radius: 8px !important;
          transition: all 0.3s ease;

          &:hover {
            background: rgba(0, 151, 215, 0.1) !important;
            color: $aqua !important;
          }

          &.v-pagination__item--active {
            background: linear-gradient(135deg, $navy 0%, $aqua 100%) !important;
            color: white !important;
          }
        }
      }
    }
  }

  // ============================================
  // ACTION ICONS
  // ============================================
  .action-icon-table {
    transition: all 0.3s ease !important;

    &:hover {
      transform: scale(1.2) !important;
      background: linear-gradient(135deg, $navy 0%, $aqua 100%) !important;
      color: white !important;
    }
  }

  // ============================================
  // STATUS CHIP
  // ============================================
  .status-chip {
    font-weight: 700 !important;
    text-transform: uppercase !important;
    letter-spacing: 0.5px !important;
    transition: all 0.3s ease !important;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
  }

  // ============================================
  // ALERT STYLES
  // ============================================
  .premium-alert {
    border-radius: 16px !important;
    border: none !important;
    overflow: hidden;
    animation: slideDown 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
    padding: 0 !important;
    position: relative;
    margin-bottom: 24px;
  }

  .premium-alert--error {
    background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%) !important;
    box-shadow: 0 12px 32px rgba(239, 68, 68, 0.3) !important;
    border-left: 5px solid #dc2626 !important;

    .premium-alert-title {
      color: #991b1b !important;
    }

    .premium-alert-message {
      color: #7f1d1d !important;
    }

    .alert-icon-wrapper {
      background: rgba(220, 38, 38, 0.1);
    }

    .alert-icon {
      color: #dc2626;
    }
  }

  .premium-alert-content {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    padding: 20px 24px;
    width: 100%;
  }

  .alert-icon-wrapper {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 12px;
    transition: all 0.3s ease;
  }

  .alert-icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .alert-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .premium-alert-title {
    font-size: 15px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .premium-alert-message {
    font-size: 14px;
    font-weight: 500;
    line-height: 1.6;
  }

  // ============================================
  // EMPTY STATE
  // ============================================
  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    text-align: center;
    background: linear-gradient(135deg, $bg-light 0%, white 100%);
    border-radius: 16px;
    border: 2px dashed $border-color;
    animation: fadeInScale 0.6s ease-out;

    h3 {
      font-size: 24px;
      font-weight: 700;
      color: $text-off-black;
      margin: 16px 0 8px 0;
    }

    p {
      font-size: 14px;
      color: $text-90-black;
      margin: 0;
    }
  }

  // ============================================
  // RESPONSIVE DESIGN
  // ============================================
  @media (max-width: 960px) {
    padding: 20px 10px;

    .header-card {
      .v-row {
        flex-direction: column;
      }
    }

    .header-title {
      font-size: 28px !important;
    }

    .header-subtitle {
      font-size: 14px !important;
    }

    .professional-table {
      thead th {
        padding: 14px 8px !important;
        font-size: 12px !important;
      }

      tbody td {
        padding: 12px 8px !important;
        font-size: 13px !important;
      }
    }
  }

  @media (max-width: 600px) {
    padding: 15px 8px;

    .header-title {
      font-size: 22px !important;
    }

    .stats-card {
      .stats-number {
        font-size: 32px;
      }
    }

    .professional-table {
      border-radius: 12px !important;

      thead th {
        padding: 10px 6px !important;
        font-size: 11px !important;
      }

      tbody td {
        padding: 10px 6px !important;
        font-size: 12px !important;
      }
    }
  }
}
</style>
